import React from 'react';
import PropTypes from 'prop-types';
import './FormFeedback.css';
import { Warning, Checkmark } from '../icons';

function FormFeedback(props) {
  const className = props.positive
    ? 'form-feedback form-feedback--positive'
    : 'form-feedback form-feedback--negative';
  return (
    <div className={className}>
      <div className="form-feedback__icon">
        {props.positive ? (
          <Checkmark width="2.4rem" height="2.4rem" />
        ) : (
          <Warning width="2.4rem" height="2.4rem" />
        )}
      </div>
      {Array.isArray(props.children) ? (
        <ul className="form-feedback__text">{props.children}</ul>
      ) : (
        <span className="form-feedback__text">{props.children}</span>
      )}
    </div>
  );
}

FormFeedback.propTypes = {
  children: PropTypes.node,
  positive: PropTypes.bool
};

FormFeedback.defaultProps = {
  children: '',
  positive: true
};

export default FormFeedback;



// WEBPACK FOOTER //
// ./src/components/form/FormFeedback.js